import { useMemo } from 'react';
import { IQueryLike } from '../../components/QueriesLoaded';

export const useQueriesLoading = (queries: IQueryLike<any>[]) => {
  return useMemo(() => {
    return queries.some((p) => p.isLoading);
  }, [queries]);
};
